(function () {
  // Header: menú móvil y buscador
  document.querySelectorAll('[data-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var header = btn.closest('.header');
      var cls = btn.getAttribute('data-toggle');
      var open = header.classList.toggle(cls);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && cls === 'search-open') {
        var input = header.querySelector('.search-bar input');
        if (input) input.focus();
      }
    });
  });

  // Filtros (puntos de venta, roster)
  document.querySelectorAll('[data-filter-group]').forEach(function (group) {
    var scope = document.getElementById(group.getAttribute('data-filter-group'));
    if (!scope) return;
    group.querySelectorAll('[data-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-filter');
        group.querySelectorAll('[data-filter]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        scope.querySelectorAll('[data-tags]').forEach(function (item) {
          var tags = item.getAttribute('data-tags').split('|');
          item.hidden = !(val === 'todos' || tags.indexOf(val) !== -1);
        });
      });
    });
  });

  // Galería de producto
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var mainImg = main.querySelector('img');
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () { showThumb(gallery, thumb); });
    });
  });
  function showThumb(gallery, thumb) {
    var main = gallery.querySelector('[data-gallery-main]');
    var img = main.querySelector('img');
    img.src = thumb.getAttribute('data-src');
    img.removeAttribute('srcset');
    img.alt = thumb.getAttribute('data-alt') || '';
    main.classList.toggle('is-photo', thumb.getAttribute('data-photo') === 'true');
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  }

  // Cantidad
  document.querySelectorAll('[data-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    box.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10));
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Variantes
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var json = form.querySelector('[data-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var btn = form.querySelector('[data-add]');
    var gallery = document.querySelector('[data-gallery]');
    var money = form.getAttribute('data-money') || '${{amount}}';
    function fmt(cents) {
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      amount = parts.join('.');
      return money.replace(/\{\{\s*\w+\s*\}\}/, amount);
    }
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option]')) return;
      var chosen = [];
      form.querySelectorAll('[data-option-group]').forEach(function (g) {
        var c = g.querySelector('input:checked');
        chosen.push(c ? c.value : null);
      });
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!v) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable'); return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
      if (v.featured_image && gallery) {
        var thumb = gallery.querySelector('[data-media-id="' + v.featured_media_id + '"]');
        if (thumb) showThumb(gallery, thumb);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  // Productos recomendados
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim().length) el.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  });

  // Carrito: actualizar al cambiar cantidad
  document.querySelectorAll('[data-cart-form] input[type="number"]').forEach(function (input) {
    input.addEventListener('change', function () {
      clearTimeout(input._t);
      input._t = setTimeout(function () { input.form.submit(); }, 500);
    });
  });
})();
